import { useTheme } from '../../../../hooks/useTheme';
import { useTranslation } from '../../../../i18n/useTranslation';
import './ThemeToggle.css';

export function ThemeToggle(): JSX.Element {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();

  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? t('themeToggle.switchToLight') : t('themeToggle.switchToDark')}
      className="theme-toggle"
      data-theme={theme}
      onClick={toggle}
      data-testid="theme-toggle"
    >
      <span className="theme-toggle__icon" aria-hidden="true">
        {isDark ? (
          /* Sun icon — shown in dark mode to indicate "switch to light" */
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="theme-toggle__sun"
            data-testid="icon-sun"
          >
            <circle cx="10" cy="10" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="10" y1="1" x2="10" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="10" y1="17" x2="10" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="1" y1="10" x2="3" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="17" y1="10" x2="19" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="3.05" y1="3.05" x2="4.46" y2="4.46" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="15.54" y1="15.54" x2="16.95" y2="16.95" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="3.05" y1="16.95" x2="4.46" y2="15.54" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="15.54" y1="4.46" x2="16.95" y2="3.05" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        ) : (
          /* Moon icon — shown in light mode to indicate "switch to dark" */
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="theme-toggle__moon"
            data-testid="icon-moon"
          >
            <path
              d="M17.5 10.9A7.5 7.5 0 0 1 9.1 2.5a7.5 7.5 0 1 0 8.4 8.4z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </button>
  );
}
